import * as $ from 'jquery';
import { Subject, Observable } from 'common/barrels/rx';
import { Lazy, disposableSubscription } from 'common/barrels/core';
import { focusin, focusout } from 'common/rxui/core';

import { Control } from 'runtime/controls/control';
import { ControlArgs } from 'runtime/controls/controlargs';
import { registerBinding } from 'runtime/bindingengine';
import { ViewInfoRequested } from 'runtime/events/viewinforequested';
import { click } from 'common/rxui/core';

import 'runtime/styles/controls/activitybutton.less';

export class ActivityButton extends Control {
    private $input: JQuery;
    private readyTrigger = new Subject<any>();
    private viewInfo = new Lazy(() => this.eventAggregator.publish(new ViewInfoRequested()));

    constructor(args: ControlArgs) {
        super(args);

        this.methods.register(this.config.elementName, this);

        this.$element.addClass('control-container activitybutton');

        var languageKey = this.config['content.LanguageKey'];

        this.$input = $('<input type="button">').addClass('ui-state-default')
            .bindVal(languageKey ? this.resources.getString(this.viewInfo.value().definitionName, languageKey) : this.config['content.Text'])
            .appendTo(this.$element);

        this.applyTooltip(this.$input);

        this.subscriptions = disposableSubscription(
            this.processBindings(this.config),
            click(this.$input).subscribe(() => this.$element.triggerHandler('events.Clicked')),
            this.readyTrigger.filter(() => this.enabled && this.visible).first().subscribe(() => this.$element.triggerHandler('events.ReadyForInput')),
            this.readyTrigger,
            Observable.interval(0).first().subscribe(() => this.readyTrigger.next(null)),
            focusin(this.$element).subscribe(() => this.$element.addClass('activitybutton-focus')),
            focusout(this.$element).subscribe(() => this.$element.removeClass('activitybutton-focus'))
        );

        this.initialize();
    }

    'content.Text'(value: string) { this.$input.val(value); }

    focus() { this.$input.focus(); }

    click() { this.$input.triggerHandler('click'); }

    isElementVisible(value: boolean) {
        super.isElementVisible(value);
        this.readyTrigger.next(null);
    }

    isElementEnabled(value: boolean) {
        super.isElementEnabled(value);
        this.readyTrigger.next(null);
    }

    applyEnabledState(value: boolean) {
        (<HTMLInputElement>this.$input[0]).disabled = !value;
    }

    tabIndexElements() {
        return this.$input;
    }
}

registerBinding('activityButton', ActivityButton);